(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('haq-evaluation-skips', {
            parent: 'entity',
            url: '/haq-evaluation-skips',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.haqEvaluationSkips.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/haq-evaluation-skips/haq-evaluation-skips.html',
                    controller: 'HaqEvaluationSkipsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('haq-evaluation-skips');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
